export function capitalize(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export function slugify(input: string) {
  // Replace whitespace with hyphens
  const nowhitespace = input.replace(/ /g, "-")

  // Normalize the string to decompose characters into combining marks and base characters,
  // then remove the combining marks
  const normalized = nowhitespace.normalize("NFD").replace(/\p{M}/g, "")

  // Match and remove any character that is not a letter, digit,
  // underscore or hyphen
  const regex = new RegExp(`[^\\p{L}\\d_.-]`, "gu")
  const slug = normalized.replace(regex, "")

  const escaped = slug.toLowerCase()

  return escaped || ""
}

/**
 * Overflows a string to a strict length
 *
 * @param str - The string to perform actions on
 * @param maxCharacters - Maximum amount of characters to display
 * @returns - A string limited to maxCharacters appended with ...
 */
export function overflow(str: string, maxCharacters: number) {
  if (str.length <= maxCharacters) return str

  return `${str?.slice(0, maxCharacters).trim()}...`
}

export function caseInsensitiveIncludes(str: string, contains: string) {
  return str.toLowerCase().includes(contains.toLowerCase())
}

/**
 * Formats a number of bytes into a human readable format
 * @param bytes - The number of bytes to format
 * @returns - A human readable string of the bytes
 */
export function formatBytes(bytes: number) {
  if (bytes === 0) return "0 Bytes"

  const sizes = ["Bytes", "KB", "MB", "GB", "TB"]

  // 1024 is the data unit base
  const index = Math.floor(Math.log(bytes) / Math.log(1024))

  const unit = sizes[index]

  if (!unit) return `${bytes} Bytes`

  return `${(bytes / Math.pow(1024, index)).toFixed(2)} ${unit}`
}
